/**
 * Add event listeners to the accordion elements.
 */
function initAccordionEvents() {
	document.querySelectorAll('.accordion-tab').forEach(($element: HTMLElement) => {
		$element.addEventListener('click', (event: Event) => {
			event.stopImmediatePropagation();
			const $accordionTab = (event.target as HTMLElement)?.closest('.accordion-tab');
			if ($accordionTab?.classList.contains('expanded')) {
				$accordionTab?.classList.remove('expanded');
			} else {
				$accordionTab?.classList.add('expanded');
			}

			document.querySelectorAll('.peachpay-accordion .expanded').forEach(($openTab: HTMLElement) => {
				const isNotEqualNode = !$openTab?.isEqualNode($accordionTab);
				// Floating dropdowns should be closed.
				const isFloatingDropdown = ($openTab.nextElementSibling as HTMLElement)?.classList.contains('dropdown');

				if (isNotEqualNode && isFloatingDropdown) {
					$openTab?.classList.remove('expanded');
				}
			});
		});
	});
}

export {initAccordionEvents};
